import React from 'react';
import styles from '../suellendiastattoo/suellendiastattoo.module.scss';
import Perfil from './src/perfil.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Suellendiastattoo: React.FC = () => {

    return (
        <div className={styles.suellendiastattoo}>
            <div className={styles["body-thunder"]}>
                <div className={`${styles["container-thunder"]}`} >
                    <img className={styles["img-perfil"]} src={Perfil} />
                    <div className={styles.links}>
                        <LinkPersonalizado7
                            href="https://wa.me/5518996372323?text=Olá, vim pelo link na bio e gostaria de mais informações..."
                            title="WHATSAPP"
                            icon={<WhatsappIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://maps.app.goo.gl/LQDpfj9V1v2gGUM8A"
                            title="LOCALIZAÇÃO"
                            icon={<MapsIcon height="40" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            href="https://www.instagram.com/suellendias.tattoo?igsh=MWx0bGJsOGIwNnE1ag=="
                            title="INSTAGRAM"
                            icon={<InstagramIcon height="32" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                        <LinkPersonalizado7
                            linkInterno={true}
                            href="/suellendiastattoo/sobremim"
                            title="SOBRE MIM"
                            icon={<CatalogIcon height="34" color="#ffffff" />}
                            colorText="#cbb353"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Suellendiastattoo;
